import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ReactDOMServer from 'react-dom/server';

export function renderMarkdown(content: string) {
  return (
    <ReactMarkdown
      className="prose dark:prose-invert max-w-none"
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({node, ...props}) => <h1 className="text-3xl font-bold mb-6 text-[--markdown-heading]" {...props} />,
        h2: ({node, ...props}) => <h2 className="text-2xl font-bold mb-4 text-[--markdown-heading] mt-8" {...props} />,
        h3: ({node, ...props}) => <h3 className="text-xl font-bold mb-3 text-[--markdown-heading] mt-6" {...props} />,
        h4: ({node, ...props}) => <h4 className="text-lg font-bold mb-2 text-[--markdown-heading] mt-6" {...props} />,
        p: ({node, ...props}) => <p className="mb-4 text-[--markdown-text] leading-relaxed" {...props} />,
        ul: ({node, ...props}) => <ul className="list-disc mb-4 pl-8 text-[--markdown-list]" {...props} />,
        ol: ({node, ...props}) => <ol className="list-decimal mb-4 pl-8 text-[--markdown-list]" {...props} />,
        li: ({node, ...props}) => <li className="mb-2" {...props} />,
        blockquote: ({node, ...props}) => (
          <blockquote className="pl-4 py-2 my-4 border-l-4 border-[--markdown-blockquote-border] bg-[--markdown-blockquote-bg] text-[--markdown-blockquote] rounded-r" {...props} />
        ),
        code: ({node, inline, ...props}) => 
          inline ? (
            <code className="px-1.5 py-0.5 rounded bg-[--markdown-code-bg] font-mono text-sm text-[--markdown-code]" {...props} />
          ) : (
            <pre className="p-4 my-4 rounded-lg bg-[--markdown-pre-bg] overflow-x-auto">
              <code className="block font-mono text-[--markdown-pre-text]" {...props} />
            </pre>
          ),
        a: ({node, ...props}) => (
          <a 
            className="text-[--markdown-link] hover:text-[--markdown-link-hover] underline"
            target="_blank"
            rel="noopener noreferrer"
            {...props}
          />
        ),
        strong: ({node, ...props}) => (
          <strong className="font-semibold text-[--markdown-bold]" {...props} />
        ),
        em: ({node, ...props}) => (
          <em className="italic text-[--markdown-italic]" {...props} />
        ),
        hr: ({node, ...props}) => (
          <hr className="my-8 border-t-2 border-[--markdown-hr]" {...props} />
        ),
        table: ({node, ...props}) => (
          <div className="overflow-x-auto my-4">
            <table className="w-full border-collapse" {...props} />
          </div>
        ),
        th: ({node, ...props}) => (
          <th className="px-4 py-2 text-left border border-[--markdown-table-border] bg-[--markdown-table-header-bg] text-[--markdown-table-header-text]" {...props} />
        ),
        td: ({node, ...props}) => (
          <td className="px-4 py-2 border border-[--markdown-table-border] text-[--markdown-table-cell]" {...props} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
}

export function renderMarkdownToHTML(content: string): string {
  const element = renderMarkdown(content);
  return ReactDOMServer.renderToStaticMarkup(element);
}